import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Row, Col } from "reactstrap/lib";
import { Card, Carousel, CarouselItem, CarouselIndicators } from "reactstrap";
import SendIcon from "@mui/icons-material/Send";
import { FormattedMessage } from "react-intl";
import { IconButton, TextField } from "@mui/material";
import {
  PostWorkCardComment,
  SignWorkCardRegistration,
} from "../../actions/teacherMutations";
import { toast } from "react-toastify";
import { BASE_LOGIN_REDIRECT_URL } from "../../constants/api.constants";
import moment from "moment";
import { FaRegThumbsUp } from "react-icons/fa";
import { FaRegComment } from "react-icons/fa";
import { PiCaretDoubleRight } from "react-icons/pi";
import { IoSchoolOutline } from "react-icons/io5";

export default function APLStudentEventCard({
  item,
  date,
  level,
  periodId,
  objectId,
}) {
  const [showComments, setShowComments] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const toggle = () => {
    setShowComments(!showComments);
    setValue("");
  };
  const [value, setValue] = useState("");

  const queryClient = useQueryClient();

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const postComment = () => {
    if (value !== "") {
      postWorkCardComment.mutate(
        {
          created: moment().format("YYYY-MM-DD HH:mm"),
          text: value,
          workRegistrationId: item.id,
        },
        {
          onSuccess: (data) => {
            item.comments.push(data.comments[0]);
            setValue("");
          },
          throwOnError: true,
          onError: (data) => {
            toast.warn(data.response.data);
          },
        }
      );
    }
  };

  const postWorkCardComment = useMutation(PostWorkCardComment);
  const signWorkCardRegistration = useMutation(SignWorkCardRegistration);

  const handleSignOrUnSignRegistration = () => {
    signWorkCardRegistration.mutate(
      {
        workRegistrationId: item.id,
        signed: !item.signedByTeacher,
      },
      {
        onSuccess: (data) => {
          queryClient.refetchQueries(
            "FetchEvents",
            [level, periodId, objectId],
            {
              active: true,
              exact: true,
            }
          );
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
        },
      }
    );
  };

  const next = () => {
    const nextIndex =
      activeIndex === item.images.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    const nextIndex =
      activeIndex === 0 ? item.images.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    setActiveIndex(newIndex);
  };

  const slides = item.images.map((image, i) => {
    return (
      <CarouselItem key={item.image + "" + i}>
        <img
          src={BASE_LOGIN_REDIRECT_URL.replace("/lwc", "") + "/" + image}
          alt=""
          style={{ borderRadius: "5px", objectFit: "contain" }}
        />
      </CarouselItem>
    );
  });
  const initials = item.studentName
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  return (
    <>
      <Card key={item.id} className="apl-moment-card shadow-sm my-2 rounded-sm">
        {item.signedBySupervisor && (
          <div className="apl-moment-card--corner-ribbon--supervisor">
            <div className="apl-moment-card--corner-ribbon__inner--supervisor">
              <div className="apl-moment-card--corner-ribbon__ribbon--supervisor">
                <FaRegThumbsUp
                  style={{ transform: "translate(-15px, -2px) rotate(-60deg)" }}
                  color={"#f5f5f5"}
                  size={"1rem"}
                />
              </div>
            </div>
          </div>
        )}
        {item.signedByTeacher && (
          <div className="apl-moment-card--corner-ribbon--teacher">
            <div className="apl-moment-card--corner-ribbon__inner--teacher">
              <div className="apl-moment-card--corner-ribbon__ribbon--teacher">
                <IoSchoolOutline
                  style={{ transform: "translate(0, -2px) rotate(-60deg)" }}
                  color={"#f5f5f5"}
                  size={"1rem"}
                />
              </div>
            </div>
          </div>
        )}
        <Col lg={12}>
          <Row className="mt-3">
            <Col style={{ flexGrow: "0" }}>
              <div className="apl-moment-card--story" title={item.studentName}>
                <span className="apl-moment-card--story--initials">
                  {initials}
                </span>
              </div>
            </Col>
            <Col>
              <Row>
                <span className="apl-moment-card--title">{item.title}</span>
              </Row>
              <Row>
                <span className="text-muted">{date.toLocaleDateString()}</span>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col className="text-muted">
              <span style={{ verticalAlign: "top" }}>
                {item.workStepComponent.workStepName}
              </span>
              <PiCaretDoubleRight />
              <span style={{ verticalAlign: "top" }}>
                {item.workStepComponent.name}
              </span>
              <PiCaretDoubleRight />
              <span style={{ verticalAlign: "top" }}>
                {item.workStepComponent.workingHours}h
              </span>
            </Col>
          </Row>
          <Row className="py-2">
            <Col>{item.bodyText}</Col>
          </Row>
          {item.images.length > 0 && (
            <Row>
              <Col className="mx-auto text-center" lg={8}>
                <Carousel
                  className="mb-4"
                  interval={false}
                  activeIndex={activeIndex}
                  next={next}
                  previous={previous}
                >
                  {item.images.length > 1 && (
                    <CarouselIndicators
                      items={item.images}
                      activeIndex={activeIndex}
                      onClickHandler={goToIndex}
                      className="event-item-carousel-indicator"
                    />
                  )}
                  {slides}
                </Carousel>
              </Col>
            </Row>
          )}

          <Row className="pb-2">
            <Col>
              <span
                style={{ paddingRight: "1rem" }}
                onClick={() => handleSignOrUnSignRegistration()}
              >
                <FaRegThumbsUp
                  color={item.signedByTeacher ? "17c333" : "black"}
                  size={"1.4rem"}
                />
              </span>
              <span onClick={toggle} style={{ cursor: "pointer" }}>
                <FaRegComment className="text-muted" size={"1.5rem"} />
                <span className="ms-1 text-muted">
                  <FormattedMessage id="DoComment" />
                </span>

                {item.comments.length > 0 && (
                  <span className="apl-moment-card--messageNumbers">
                    {item.comments.length}
                  </span>
                )}
              </span>
            </Col>
          </Row>
          {showComments && (
            <div className="mt-3">
              {item.comments.map((comment) => {
                var date = new Date(comment.commentDate);
                return (
                  <div className="mb-2" key={"comment" + comment.id}>
                    <Row style={{ width: "100%" }}>
                      <Col>
                        <span>
                          <span
                            className="pb-0 mb-0"
                            style={{ fontWeight: "bold" }}
                          >
                            {comment.commenterName}
                          </span>
                          &nbsp;&nbsp;
                          {comment.text}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <span style={{ fontSize: "smaller" }}>
                          {date.toLocaleDateString()}
                        </span>
                      </Col>
                    </Row>
                  </div>
                );
              })}
              <Row className="mb-2">
                <Col>
                  <TextField
                    size="small"
                    className="mt-2"
                    style={{ width: "100%" }}
                    id="comment"
                    label={<FormattedMessage id="DoComment" />}
                    value={value}
                    onChange={handleChange}
                    InputProps={{
                      endAdornment: (
                        <IconButton onClick={postComment}>
                          <SendIcon />
                        </IconButton>
                      ),
                    }}
                    onKeyPress={(ev) => {
                      if (ev.key === "Enter") {
                        postComment();
                        ev.preventDefault();
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
          )}
        </Col>
      </Card>
    </>
  );
}
